import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getModulesList,createTemplateModule,updateModule,deleteModule} from "../actions/report_module_action";

export default function ReportModulesContainer(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({getModulesList,createTemplateModule,updateModule,deleteModule}, dispatch);
}

function mapStateToProps(state) {
    return {
        modules:state.reportModule.modules,
    };
}



// WEBPACK FOOTER //
// ./src/containers/report_module_container.js